import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

import {
    Shield,
    UserCheck,
    Scale,
    Users,
    Heart,
    Brain,
    Building,
    Gavel,
    GraduationCap,
    Briefcase,
    Stethoscope,
} from "lucide-react";

/* ---------------- ROLES ---------------- */
const ROLES = [
    { label: "Polițist", icon: Shield },
    { label: "Consilier de probațiune", icon: UserCheck },
    { label: "Judecător", icon: Scale },
    { label: "Mediator", icon: Users },
    { label: "Specialist în protecția copilului", icon: Heart },
    { label: "Psiholog", icon: Brain },
    { label: "Lucrător de tineret", icon: Users },
    { label: "Primar", icon: Building },
    { label: "Procuror", icon: Gavel },
    { label: "Profesor", icon: GraduationCap },
    { label: "Avocat", icon: Briefcase },
    { label: "Medic", icon: Stethoscope },
];

export default function Ecran6() {
    const navigate = useNavigate();

    const [role, setRole] = useState("");
    const [invatare, setInvatare] = useState("");

    const [calitati, setCalitati] = useState("");
    const [dificultati, setDificultati] = useState("");

    const isValid = role && invatare.trim().length >= 5;

    /* 🔍 DEBUG */
    console.log("ROLE:", role);
    console.log("INVATARE:", invatare);
    console.log("VALID:", isValid);
    console.log("PASSPORT:", localStorage.getItem("pasaportId"));

    const saveAndContinue = async () => {
        if (!isValid) {
            alert("Completează corect câmpurile!");
            return;
        }

        const pasaportId = localStorage.getItem("pasaportId");

        if (!pasaportId) {
            alert("Nu există ID în localStorage");
            return;
        }

        try {
            await updateDoc(doc(db, "pasapoarteCivice", pasaportId), {
                rolJucat: role,
                ceAmInvatatDespreRol: invatare.trim(),
                rolUpdatedAt: serverTimestamp(),
            });

            console.log("SALVAT CU SUCCES");
            navigate("/ecran7");

        } catch (err) {
            console.error("EROARE FIREBASE:", err);
            alert("Eroare la salvare (rules / auth)");
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#EEEEEE] to-[#e2e8f0] p-8 md:p-20">
            <div className="max-w-5xl mx-auto space-y-12">

                {/* HEADER */}
                <header>
                    <h1 className="text-4xl md:text-5xl font-black text-[#0F044C] mb-4">
                        Nivelul 6 – EU ÎN ROL CIVIC
                    </h1>
                </header>

                {/* ROLE SELECT */}
                <section className="bg-white/80 rounded-[2rem] p-8 shadow">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {ROLES.map((r) => {
                            const Icon = r.icon;
                            const active = role === r.label;

                            return (
                                <button
                                    key={r.label}
                                    onClick={() => setRole(r.label)}
                                    className={`flex flex-col items-center gap-3 p-5 rounded-2xl border transition
                                    ${
                                        active
                                            ? "bg-[#0F044C] text-white"
                                            : "bg-white hover:bg-[#0F044C]/5"
                                    }`}
                                >
                                    <Icon size={24} />
                                    <span className="text-sm font-bold text-center">
                                        {r.label}
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                </section>

                {/* QUESTIONS */}
                <section className="bg-white/80 rounded-[2rem] p-8 shadow space-y-6">

                    <textarea
                        value={invatare}
                        onChange={(e) => setInvatare(e.target.value)}
                        className="w-full h-28 p-4 rounded-xl border"
                        placeholder="Ce ai învățat?"
                    />

                    <textarea
                        value={calitati}
                        onChange={(e) => setCalitati(e.target.value)}
                        className="w-full h-24 p-4 rounded-xl border"
                        placeholder="Calități"
                    />

                    <textarea
                        value={dificultati}
                        onChange={(e) => setDificultati(e.target.value)}
                        className="w-full h-24 p-4 rounded-xl border"
                        placeholder="Dificultăți"
                    />

                </section>

                {/* BUTTON */}
                <div className="flex justify-end">
                    <button
                        disabled={!isValid}
                        onClick={saveAndContinue}
                        className={`px-8 py-4 rounded-xl font-bold ${
                            isValid
                                ? "bg-[#0F044C] text-white"
                                : "bg-gray-300 cursor-not-allowed"
                        }`}
                    >
                        Continuă
                    </button>
                </div>

            </div>
        </div>
    );
}